import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import { GameProvider } from "./context/GameContext";
import { SettingsProvider } from "./context/SettingsContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import GameSetupPage from "./pages/GameSetupPage";
import GamePlayPage from "./pages/GamePlayPage";
import ResultsPage from "./pages/ResultsPage";
import GameHistoryPage from "./pages/GameHistoryPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import ExplorePage from "./pages/ExplorePage";
import AboutPage from "./pages/AboutPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import ContactPage from "./pages/ContactPage";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SettingsProvider>
      <GameProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/game/:mode" element={<GameSetupPage />} />
              <Route path="/game/play" element={<GamePlayPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/explore" element={<ExplorePage />} />
              <Route path="/history" element={<GameHistoryPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </GameProvider>
      </SettingsProvider>
    </ThemeProvider>
  );
}
